<script lang="ts">
  import { _ as t } from "svelte-i18n";
  import CenterDialog from "./CenterDialog.svelte";
  import successIcon from "../assets/images/dialog/success.png";
  import redeemSuccessIcon from "../assets/images/dialog/success2-icon.png";
  import ineligibleIcon from "../assets/images/dialog/statu-icon.png";
  import qrFailIcon from "../assets/images/dialog/qr-fail.png";
  import qrDoneIcon from "../assets/images/dialog/qr-done.png";

  type DialogType =
    | "confirm"
    | "goToApp"
    | "registerSuccess"
    | "redeemSuccess"
    | "redeemIneligible"
    | "qrAlreadyUsed"
    | "userAlreadyRedeemed"
    | "qrInvalid"
    | "enrollIneligible"
    | "accountNotOpened"
    | "activityNotInPeriod"
    | "requestFailed";

  interface Props {
    show: boolean;
    type: DialogType | null;
    onClose: () => void;
    onConfirm: () => void;
  }

  let { show, type, onClose, onConfirm }: Props = $props();

  // 关闭时调用方会把 type 置空，但弹窗还要淡出 200ms。
  // 这里缓存最后一次有效类型，避免淡出期间内容闪成兜底文案（标题/图标/按钮数量突变）。
  let cachedType = $state<DialogType | null>(null);

  // 用 $effect 同步 cachedType，避免在 $derived 内产生副作用
  $effect(() => {
    if (type !== null) cachedType = type;
  });

  let config = $derived.by(() => {
    switch (cachedType) {
      case "confirm":
        return { title: $t("register_confirm_title"), cancel: true };
      case "goToApp":
        return {
          title: $t("go_to_app_title"),
          cancel: true,
          confirmText: $t("btn_confirm"),
        };
      case "registerSuccess":
        return {
          title: $t("register_success_title"),
          desc: $t("register_success_desc"),
          icon: successIcon,
          width: 238,
          height: 144,
        };
      case "redeemSuccess":
        return {
          title: $t("redeem_success_title"),
          icon: redeemSuccessIcon,
          width: 160,
          height: 135,
        };
      case "redeemIneligible":
        return {
          title: $t("redeem_ineligible_title"),
          icon: ineligibleIcon,
          width: 148,
          height: 148,
        };
      case "qrAlreadyUsed":
        return {
          title: $t("redeem_failed_title"),
          desc: $t("redeem_already_used_desc"),
          icon: qrDoneIcon,
          width: 160,
          height: 138,
        };
      case "userAlreadyRedeemed":
        return {
          title: $t("redeem_user_already_redeemed_title"),
          cancel: true,
        };
      case "qrInvalid":
        return {
          title: $t("redeem_failed_title"),
          desc: $t("redeem_invalid_desc"),
          icon: qrFailIcon,
          width: 160,
          height: 136,
        };
      case "enrollIneligible":
        return { title: $t("enroll_ineligible_title") };
      case "accountNotOpened":
        return {
          title: $t("account_not_opened_title"),
          cancel: true,
          confirmText: $t("btn_open_account"),
        };
      case "activityNotInPeriod":
        return { title: $t("activity_not_in_period_title") };
      default:
        return { title: $t("request_failed_title") };
    }
  });
</script>

<CenterDialog
  {show}
  showCancel={config.cancel ?? false}
  confirmText={config.confirmText}
  onCancel={onClose}
  {onConfirm}
  {onClose}
>
  {#if config.icon}
    <img
      src={config.icon}
      alt=""
      class="block mx-auto"
      style="width: {config.width}px; height: {config.height}px;"
    />
  {/if}
  <p class="mt-[12px] text-[16px] font-[500] leading-[24px] text-[#1D1D1D]">
    {config.title}
  </p>
  {#if config.desc}
    <p class="mt-[4px] text-[14px] leading-[22px] text-[#1D1D1D99]">
      {config.desc}
    </p>
  {/if}
</CenterDialog>
